<script lang="ts" setup>
  import { getServiceName } from '@/utils/branding';

  const emit = defineEmits<{ retry: [] }>();
  const statusUrl = window.__VITE_ENVS.SERVICE_STATUS_URL as string;
  const serviceName = getServiceName();

  const { t } = useI18n({
    messages: {
      ru: {
        title: '{serviceName} не отвечает',
        description: 'Проверьте подключение к сети или попробуйте позже. Мы повторим попытку автоматически.',
        retry: 'Повторить',
        status: 'Статус сервиса',
      },
      en: {
        title: '{serviceName} is not responding',
        description: 'Check your network connection or try again later. We will retry automatically.',
        retry: 'Retry',
        status: 'Service status',
      },
    },
  });
</script>

<template>
  <VBaseLayout :title="t('title', { serviceName })">
    <VCloudStatusBanner class="container-fluid mt-16" />
    <main class="min-h-320 h-full px-16 flex flex-col justify-center items-center gap-16 text-center">
      <h1 data-testid="error-title" class="text-xl font-bold">{{ t('title', { serviceName }) }}</h1>
      <p>{{ t('description') }}</p>
      <Button data-testid="error-retry" :label="t('retry')" @click="emit('retry')" />
      <a v-if="statusUrl" class="link" target="_blank" :href="statusUrl">{{ t('status') }}</a>
    </main>
  </VBaseLayout>
</template>
